import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import PageLayout from '../../components/common/PageLayout';
import { ProductsFeeds } from '../../components/pages/ProductsFeeds';
import { TAB_CHANNELS, TAB_INGESTION_TO_CYMBIO } from '../../constants/productsFeeds';
import { InfoTitle } from '../../components/common/InfoTooltip';

export default function ProductsFeedsPageContainer() {
  const title = (
    <InfoTitle content="Currently unavailable. Stay tuned for future updates!">
      <span style={{ cursor: 'not-allowed' }}>{TAB_CHANNELS}</span>
    </InfoTitle>
  );

  return (
    <PageLayout>
      <>
        <h1 style={{ marginBottom: '1em' }}>Product Feeds</h1>

        <Tabs
          activeKey={TAB_INGESTION_TO_CYMBIO}
          defaultActiveKey={TAB_INGESTION_TO_CYMBIO}
          className="tabs"
          onSelect={() => {}}
          style={{ marginBottom: 32 }}
        >
          <Tab eventKey={TAB_INGESTION_TO_CYMBIO} title={TAB_INGESTION_TO_CYMBIO} />
          <Tab eventKey={TAB_CHANNELS} title={title} />
        </Tabs>

        <ProductsFeeds />
      </>
    </PageLayout>
  );
}
